import React, { Component, Fragment } from "react";
import { Form, Radio, Input, Checkbox } from "antd";
import { observer } from "mobx-react";
import styles from "../index.module.less";

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@observer
class WordAI extends Component {
	render() {
		return (
			<Fragment>
				<Form layout="vertical" className={styles.rxform}>
					<FormItem label="Email address">
						{this.props.form.getFieldDecorator("wordAi.email")(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="API Key">
						{this.props.form.getFieldDecorator("wordAi.password")(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="Quality">
						{this.props.form.getFieldDecorator("wordAi.quality")(
							<RadioGroup>
								<RadioButton value={1}>Regular</RadioButton>
								<RadioButton value={2}>Unique</RadioButton>
								<RadioButton value={3}>Very Unique</RadioButton>
								<RadioButton value={4}>Readable</RadioButton>
								<RadioButton value={5}>Very Readable</RadioButton>
							</RadioGroup>
						)}
					</FormItem>
				</Form>
				<Form layout="inline">
					<FormItem>
						{this.props.form.getFieldDecorator("wordAi.nonested", {
							valuePropName: "checked"
						})(<Checkbox>No Nested</Checkbox>)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("wordAi.sentence", {
							valuePropName: "checked"
						})(<Checkbox>Sentence</Checkbox>)}						
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("wordAi.paragraph", {
							valuePropName: "checked"
						})(<Checkbox>Paragraph</Checkbox>)}						
					</FormItem>
				</Form>
			</Fragment>
		);
	}
}

export default WordAI;
